module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 121.991ee6e2.png";